/*
Shared training log functionality.
*/

export { initTrainingLogForm, submitTrainingLogEntry } from './form'
